import { useCallback, useState } from "react";
import { getListState, setListState } from "../lib/listStateStore";

// Drop-in replacement for useState() whose value is remembered across
// unmount/remount within the same top-level section — e.g. switching tabs
// within a page, or navigating to a Detail page and back. Key convention:
// "<section>.<field>", e.g. "customers.search" (section must match the
// route's top-level path segment so SectionStateGuard can clear it correctly).
export function useListState(key, initialValue) {
  const [value, setValue] = useState(() => getListState(key, initialValue));

  const setAndStore = useCallback((next) => {
    setValue((prev) => {
      const resolved = typeof next === "function" ? next(prev) : next;
      setListState(key, resolved);
      return resolved;
    });
  }, [key]);

  return [value, setAndStore];
}
